import React from 'react'
import Divider from './divider'
import Stack from './stack'
import Button from './button'
import { motion, AnimatePresence } from 'framer-motion'

interface IModalProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  isVisible?: boolean
  onClose: () => void
}

const Modal: React.FC<IModalProps & any> = ({
  children,
  title,
  onClose,
  isVisible,
  ...rest
}) => {
  React.useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.keyCode === 27) {
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onClose])

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ backgroundColor: 'rgba(0, 0, 0, 0.0)' }}
          animate={{ backgroundColor: 'rgba(0, 0, 0, 0.65)' }}
          exit={{ backgroundColor: 'rgba(0, 0, 0, 0.0)' }}
          className='modal-wrapper'
        >
          <div className='modal-click-surface' onClick={onClose} />
          <motion.div
            initial={{ y: 300, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 300, opacity: 0 }}
            transition={{ ease: 'easeOut' }}
            className='modal-window'
            {...rest}
          >
            {title && (
              <React.Fragment>
                <div className='modal-header'>
                  <Stack
                    align='center'
                    style={{ justifyContent: 'space-between' }}
                  >
                    <h3>{title}</h3>
                    <Button
                      style={{ padding: '0 auto' }}
                      onClick={onClose}
                      variant='link'
                    >
                      Close
                    </Button>
                  </Stack>
                </div>
                <Divider />
              </React.Fragment>
            )}
            <div className='modal-content'>{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Modal
